import {
  ArrowDownIcon,
  ArrowUpIcon,
  CaretSortIcon,
} from '@radix-ui/react-icons'
import { Column } from '@tanstack/react-table'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

interface DataTableColumnHeaderProps<TData, TValue>
  extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<TData, TValue>
  title: string
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return (
      <div className={cn('font-semibold uppercase tracking-wider text-xs text-muted-foreground my-2', className)}>
        {title}
      </div>
    )
  }

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      <Button
        variant='ghost'
        size='sm'
        className='-ms-3 h-8 px-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground hover:text-foreground'
        onClick={() => column.toggleSorting()}
      >
        <span>{title}</span>
        {column.getIsSorted() === 'desc' ? (
          <ArrowDownIcon className='ms-2 h-4 w-4 text-primary' />
        ) : column.getIsSorted() === 'asc' ? (
          <ArrowUpIcon className='ms-2 h-4 w-4 text-primary' />
        ) : (
          <CaretSortIcon className='ms-2 h-4 w-4 opacity-60' />
        )}
      </Button>
    </div>
  )
}
